import KYCSubmissionStatus from "enums/kyc-submission-status";
import { KycType } from "../../../enums/kyc-type";

export const initialFilterState = () => ({
  startDate: null,
  endDate: null,
  searchKey: "",
  page: 1,
  perPage: 10,
  verificationStatuses: [KYCSubmissionStatus.Pending],
  kycTypes: [KycType.VerifiedAccount],
});
